export default "__VITE_ASSET__DYmcGxIo__"